<div class="container">
  <ngx-spinner></ngx-spinner>

  <div class="search-form">
    <form (ngSubmit)="onSearch()" class="search-form">
      <div class="search-fields">
        <mat-form-field appearance="fill">
          <mat-label>Company Name</mat-label>
          <input matInput [(ngModel)]="searchForm.companyName" name="companyName" placeholder="Search by name">
        </mat-form-field>
      </div>

      <div class="search-actions">
        <button mat-flat-button color="primary" type="submit" [disabled]="!searchForm.companyName">
          <mat-icon>search</mat-icon>
          Search
        </button>
      </div>
    </form>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2" [hidden]="!dataSource.data || dataSource.data.length === 0">
      <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Name</th>
        <td mat-cell *matCellDef="let item">{{ item.companyName }}</td>
      </ng-container>

      <ng-container matColumnDef="countryName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
        <td mat-cell *matCellDef="let item">{{ item.countryName }}</td>
      </ng-container>

      <ng-container matColumnDef="industryName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Industry</th>
        <td mat-cell *matCellDef="let item">{{ item.industryName }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button mat-icon-button (click)="onConnect(item)">
            <mat-icon>{{ isSelected(item) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'right-row': isSelected(row)}"></tr>
    </table>

    @if (!dataSource.data || dataSource.data.length === 0) {
      <div class="empty-state">
        No companies found. Please search to see results.
      </div>
    }

    <mat-paginator
      [pageSize]="pageSize"
      [showFirstLastButtons]="true"
      [hidden]="!dataSource.data || dataSource.data.length === 0"
      aria-label="Select page">
    </mat-paginator>
  </div>
</div>
